import React, { FC } from 'react'
import TextType, { TextProps } from './TextType'

const ColorType: FC<TextProps> = ({ ...rest }) => <TextType type="color" {...rest} />

export default ColorType
